import { FC } from "react";
import classnames from 'classnames';
import { LayOutPageLeftItemProps, LayOutPageItemEnum, } from "../interface";

const LayOutPageLeftItem: FC<LayOutPageLeftItemProps> = props => {
  const { children, className, ...restProps } = props;
  const classes = classnames('yb-layout-page-lefts-item', className);
  return (
    <div className={classes} {...restProps}>
      {children}
    </div>
  );
};

LayOutPageLeftItem.displayName = LayOutPageItemEnum.LeftItem;

export default LayOutPageLeftItem;